module.exports = __webpack_public_path__ + "img/FastMove-80.9c67270a.gif";